export class WebSocketAdapter {
    socket;
    constructor(endpoint, _certVerification) {
        this.socket = new WebSocket(endpoint);
        this.socket.binaryType = 'arraybuffer';
    }
    send(message) {
        this.socket.send(message);
        return Promise.resolve();
    }
    close() {
        this.socket.close();
    }
    setOnOpen(callback) {
        this.socket.onopen = callback;
    }
    setOnClose(callback) {
        this.socket.onclose = callback;
    }
    setOnError(callback) {
        this.socket.onerror = callback;
    }
    setOnMessage(callback) {
        /**
         * Note that MessageEvent is type to be ArrayBuffer because we have
         *  set binaryType = 'arraybuffer' in the constructor
         */
        this.socket.onmessage = (event) => {
            callback(new Uint8Array(event.data));
        };
    }
}
